import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={10} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Benefits of Working With A Top-Grade Unity Game Development Company</h2>
                        <p>Partnering with a top-grade Unity Game Development Company brings numerous advantages. Here's why:</p>
                    </Col>
                </Row>
                <Row className="h-100 perks-padd">
                <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                    <div className="perks-box">
                        <div className="perks-content">
                            <h4>Expertise and Proficiency</h4>
                            <p>Benefit from the expertise and proficiency of seasoned Unity game developers, ensuring your project is in capable hands.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Tailored Solutions for Your Vision</h4>
                            <p>A top-grade Unity game development company customizes solutions to match your unique vision, creating games that stand out.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Efficient Development Processes</h4>
                            <p>Streamline your game development with efficient processes, ensuring timely delivery and optimal performance.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                 <div className="perks-box">
                        <div className="perks-content">
                            <h4>Diverse Genre Specialization</h4>
                            <p>Tap into a company's experience across various genres, ensuring they can adeptly handle the specific requirements of your game.</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Perks